/**
 * Tên quốc gia tiếng Việt từ mã ISO hai chữ mà YouTube trả về.
 *
 * Dùng `Intl.DisplayNames` để không phải nuôi một bảng 250 dòng; trình duyệt nào
 * không có thì giữ nguyên mã.
 */

let bo: Intl.DisplayNames | null | undefined;

function boTen(): Intl.DisplayNames | null {
  if (bo !== undefined) return bo;

  try {
    bo = new Intl.DisplayNames(['vi'], { type: 'region' });
  } catch {
    bo = null;
  }
  return bo;
}

export function tenQuocGia(ma: string): string {
  /* YouTube dùng `ZZ` cho "không xác định". */
  if (ma === 'ZZ') return 'Không xác định';

  try {
    return boTen()?.of(ma) ?? ma;
  } catch {
    return ma;
  }
}
